import { ScanResult } from '@capacitor-community/bluetooth-le';
import { Observable } from 'rxjs';

import { StickModelType } from '../upgrade/upgrade.config';
import { ModbusLink } from '../lib/modbus.model';
import { ConcurrentQuery } from '../lib/inverter.model';

export type TypeLanDevice = {
  address: string;
  port: number;
  serial: number;
  model?: StickModelType;
  inverterSerial?: string;
};

export type TypeInternetDevice = {
  serial?: string;
  loggerId?: number;
  gatewaySN?: string;
  deviceType?: string;
  modbusAddress?: number;
  onFatalError?: () => void;
};

export interface CommunicationChannel {
  readonly response$: Observable<Uint8Array>;
  readonly connectionStatus$: Observable<boolean>;
  command?: ModbusLink;
  loggerId?: number;
  deviceId?: string;
  inverterId?: string;
  isConnected: boolean;
  refreshByDefault: number;
  concurrentQuery: ConcurrentQuery;

  close(): Promise<void>;
  interaction(cmd: Uint8Array): Promise<Uint8Array>;
  scan(): Promise<void>;
  open(scanResult: ScanResult | TypeLanDevice | TypeInternetDevice): Promise<void>;
}

export enum CommunicationChannelType {
  BluetoothLe = 'bluetooth-le',
  BluetoothMockup = 'bluetooth-mockup',
  Lan = 'lan',
  Internet = 'internet',
  InternetMQTT_ZCS = 'internet-mqtt-zcs',
  InternetETHLongPolling_ZCS = 'internet-eth-long-polling-zcs',
  InternetAH_ZCS = 'internet-ah-zcs'
}
